// extracted by mini-css-extract-plugin
module.exports = {"appBtn":"app-button_appBtn__3RZ6u","blue":"app-button_blue__2D4gg","outlined":"app-button_outlined__3Nch_","filled":"app-button_filled__23mk9","orange":"app-button_orange__3z2iY"};